export default __webpack_public_path__ + "static/media/vi.43c5684d.png";